// インドの森: 送料無料プログレスバー（カートドロワー内）
// 2026-04-28 追加。Shopify国内配送設定（国内配送ゾーン）と一致
(function () {
  const THRESHOLD_GRAMS = 3251;

  // 国内配送（日本）の重量別送料テーブル（Shopify shipping_zones と同期）
  // [上限グラム, 円] — 上から順に判定
  const DOMESTIC_RATES = [
    [250, 2800],
    [500, 2600],
    [750, 2400],
    [1000, 2200],
    [1250, 1900],
    [1500, 1700],
    [1750, 1500],
    [2000, 1300],
    [2250, 1100],
    [2500, 800],
    [2750, 600],
    [3000, 400],
    [3250, 200],
    [Infinity, 0],
  ];

  function estimateShipping(weight) {
    if (weight <= 0) return null;
    for (let i = 0; i < DOMESTIC_RATES.length; i++) {
      if (weight <= DOMESTIC_RATES[i][0]) return DOMESTIC_RATES[i][1];
    }
    return 0;
  }

  function fmtJpy(n) {
    return '¥' + n.toLocaleString('ja-JP');
  }

  function fmtKg(g, digits) {
    if (digits === undefined) digits = 2;
    return (g / 1000).toFixed(digits) + 'kg';
  }

  function buildBar(weight) {
    const remaining = Math.max(0, THRESHOLD_GRAMS - weight);
    const pct = Math.min(100, Math.round((weight / THRESHOLD_GRAMS) * 100));
    const qualified = weight >= THRESHOLD_GRAMS;
    const msg = qualified
      ? '<span class="qualified">✓ 送料無料の対象です！</span>'
      : 'あと <strong>' + fmtKg(remaining) + '</strong> で日本全国送料無料！';
    const shipping = estimateShipping(weight);
    const shippingLabel =
      shipping === null
        ? '—'
        : shipping === 0
        ? '<span class="qualified">無料</span>'
        : fmtJpy(shipping);
    const weightLine =
      '<p class="free-shipping-progress__weight">現在のカート重量：<strong>' +
      fmtKg(weight) +
      '</strong> <span class="free-shipping-progress__threshold">／ 無料ライン ' +
      fmtKg(THRESHOLD_GRAMS, 3) +
      '</span></p>' +
      '<p class="free-shipping-progress__shipping">' +
      '日本国内 送料目安：<strong>' + shippingLabel + '</strong>' +
      '</p>';
    return (
      '<div class="free-shipping-progress" data-qualified="' + qualified + '">' +
      '<p class="free-shipping-progress__msg">' + msg + '</p>' +
      weightLine +
      '<div class="free-shipping-progress__bar">' +
      '<div class="free-shipping-progress__fill" style="width:' + pct + '%"></div>' +
      '</div></div>'
    );
  }

  function updateBars(weight) {
    document.querySelectorAll('.free-shipping-progress-mount').forEach(function (host) {
      host.innerHTML = buildBar(weight);
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ensureMountPoints();
        updateBars(cart.total_weight || 0);
      })
      .catch(function () {});
  }

  function ensureMountPoints() {
    // Cart drawer: single mount inside cart-drawer (only one)
    const drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.querySelector('.free-shipping-progress-mount')) {
      const target = drawer.querySelector('.cart-drawer__form, .drawer__contents, .drawer__inner') || drawer;
      const mount = document.createElement('div');
      mount.className = 'free-shipping-progress-mount';
      target.prepend(mount);
    }
    // Cart page: above cart items
    const cartItems = document.querySelector('main cart-items, main #main-cart-items');
    if (cartItems && !cartItems.parentNode.querySelector('.free-shipping-progress-mount')) {
      const mount = document.createElement('div');
      mount.className = 'free-shipping-progress-mount';
      cartItems.parentNode.insertBefore(mount, cartItems);
    }
  }

  // Initial render
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);
  } else {
    fetchCartAndUpdate();
  }

  // Re-render on cart updates (Shopify dispatches these in modern themes)
  document.addEventListener('cart:updated', fetchCartAndUpdate);
  document.addEventListener('cart-drawer:open', fetchCartAndUpdate);

  // Hook ajax cart adds: Shopify themes often POST to /cart/add.js
  const _fetch = window.fetch;
  window.fetch = function () {
    const result = _fetch.apply(this, arguments);
    try {
      const url = String(arguments[0] || '');
      if (url.indexOf('/cart/') !== -1) {
        result.then(function () { setTimeout(fetchCartAndUpdate, 200); });
      }
    } catch (e) {}
    return result;
  };
})();
